import axiosInstance from '../axiosInstance';
import { toast } from 'sonner';
import { financePath } from '../../../utils/financePath';

const API = 'credit';

export const CREDIT_ACTIONS = {
  FETCH_PARTIES_START: 'CREDIT_FETCH_PARTIES_START',
  FETCH_PARTIES_SUCCESS: 'CREDIT_FETCH_PARTIES_SUCCESS',
  FETCH_PARTIES_FAIL: 'CREDIT_FETCH_PARTIES_FAIL',

  FETCH_LOANS_START: 'CREDIT_FETCH_LOANS_START',
  FETCH_LOANS_SUCCESS: 'CREDIT_FETCH_LOANS_SUCCESS',
  FETCH_LOANS_FAIL: 'CREDIT_FETCH_LOANS_FAIL',

  SET_SUMMARY: 'CREDIT_SET_SUMMARY',

  ACTION_START: 'CREDIT_ACTION_START',
  ACTION_END: 'CREDIT_ACTION_END',
};

// ══════════════════════════════════════════════════════════════
//  PARTIES
// ══════════════════════════════════════════════════════════════

export const Fetch_Credit_Parties = (params = {}) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.FETCH_PARTIES_START });
  try {
    const { data } = await axiosInstance.get(financePath(`credit/parties`), { params });
    dispatch({ type: CREDIT_ACTIONS.FETCH_PARTIES_SUCCESS, payload: data.data.parties });
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.FETCH_PARTIES_FAIL });
    toast.error(err.response?.data?.error || 'Failed to fetch parties');
  }
};

export const Get_Credit_Party_By_Id = (id) => async () => {
  try {
    const { data } = await axiosInstance.get(financePath(`credit/parties/${id}`));
    return data.data;
  } catch (err) {
    toast.error('Failed to fetch party details');
    return null;
  }
};

export const Create_Credit_Party = (partyData) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.post(financePath(`credit/parties`), partyData);
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to create party');
    throw err;
  }
};

export const Update_Credit_Party = (id, partyData) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.put(financePath(`credit/parties/${id}`), partyData);
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to update party');
    throw err;
  }
};

export const Delete_Credit_Party = (id) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    await axiosInstance.delete(financePath(`credit/parties/${id}`));
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return true;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to delete party');
    return false;
  }
};

// ══════════════════════════════════════════════════════════════
//  LOANS
// ══════════════════════════════════════════════════════════════

export const Fetch_Credit_Loans = (params = {}) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.FETCH_LOANS_START });
  try {
    const { data } = await axiosInstance.get(financePath(`credit/loans`), { params });
    dispatch({ type: CREDIT_ACTIONS.FETCH_LOANS_SUCCESS, payload: data.data.loans });
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.FETCH_LOANS_FAIL });
    toast.error(err.response?.data?.error || 'Failed to fetch loans');
  }
};

export const Fetch_Credit_Summary = (params = {}) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(financePath(`credit/summary`), { params });
    dispatch({ type: CREDIT_ACTIONS.SET_SUMMARY, payload: data.data });
  } catch (err) {}
};

export const Get_Credit_Loan_By_Id = (id) => async () => {
  try {
    const { data } = await axiosInstance.get(financePath(`credit/loans/${id}`));
    return data.data;
  } catch (err) {
    toast.error('Failed to fetch loan details');
    return null;
  }
};

export const Create_Credit_Loan = (loanData) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.post(financePath(`credit/loans`), loanData);
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to create loan');
    throw err;
  }
};

export const Update_Credit_Loan = (id, loanData) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.put(financePath(`credit/loans/${id}`), loanData);
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to update loan');
    throw err;
  }
};

export const Delete_Credit_Loan = (id) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    await axiosInstance.delete(financePath(`credit/loans/${id}`));
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return true;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to delete loan');
    return false;
  }
};

// ══════════════════════════════════════════════════════════════
//  REPAYMENTS
// ══════════════════════════════════════════════════════════════

export const Add_Credit_Repayment = (loanId, repaymentData) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    await axiosInstance.post(financePath(`credit/loans/${loanId}/repayments`), repaymentData);
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return true;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to record payment');
    return false;
  }
};

export const Delete_Credit_Repayment = (loanId, repaymentId) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    await axiosInstance.delete(financePath(`credit/loans/${loanId}/repayments/${repaymentId}`));
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return true;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to reverse payment');
    return false;
  }
};

// ══════════════════════════════════════════════════════════════
//  COMMITTEE (BC)  — redux state nahi, har action data return karta he
// ══════════════════════════════════════════════════════════════

const bcError = (err, fallback) => {
  const msg = err.response?.data?.error || fallback;
  toast.error(msg);
  return msg;
};

export const Fetch_Credit_Bc = (params = {}) => async () => {
  try {
    const { data } = await axiosInstance.get(financePath(`credit/bc`), { params });
    return data.data;
  } catch (err) {
    bcError(err, 'Failed to fetch Committee (BC) list');
    return null;
  }
};

// Company ke allowed BC types: { simple, variable } (Company Permissions: bc.simple / bc.variable)
export const Fetch_Credit_Bc_Types = (params = {}) => async () => {
  try {
    const { data } = await axiosInstance.get(financePath(`credit/bc/types`), { params });
    return data.data;
  } catch (err) {
    return null;
  }
};

export const Fetch_Credit_Bc_Summary = (params = {}) => async () => {
  try {
    const { data } = await axiosInstance.get(financePath(`credit/bc/summary`), { params });
    return data.data;
  } catch (err) {
    return null;
  }
};

export const Get_Credit_Bc = (id, params = {}) => async () => {
  try {
    const { data } = await axiosInstance.get(financePath(`credit/bc/${id}`), { params });
    return data.data;
  } catch (err) {
    bcError(err, 'Failed to fetch Committee (BC) details');
    return null;
  }
};

export const Create_Credit_Bc = (payload) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.post(financePath(`credit/bc`), payload);
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    bcError(err, 'Failed to create Committee (BC)');
    return null;
  }
};

export const Update_Credit_Bc = (id, payload) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.put(financePath(`credit/bc/${id}`), payload);
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    bcError(err, 'Failed to update Committee (BC)');
    return null;
  }
};

export const Delete_Credit_Bc = (id, params = {}) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    await axiosInstance.delete(financePath(`credit/bc/${id}`), { params });
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return true;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    bcError(err, 'Failed to delete Committee (BC)');
    return false;
  }
};

export const Add_Credit_Bc_Entry = (id, payload) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.post(financePath(`credit/bc/${id}/entries`), payload);
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    bcError(err, 'Failed to add Committee (BC) entry');
    return null;
  }
};

export const Delete_Credit_Bc_Entry = (id, entryId, params = {}) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.delete(financePath(`credit/bc/${id}/entries/${entryId}`), { params });
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    bcError(err, 'Failed to delete Committee (BC) entry');
    return null;
  }
};

// Variable BC: manual close / reopen. company_id body me jati he (owner ke liye zaroori).
export const Close_Credit_Bc = (id, params = {}) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.post(financePath(`credit/bc/${id}/close`), { ...params });
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    bcError(err, 'Failed to close Committee (BC)');
    return null;
  }
};

export const Reopen_Credit_Bc = (id, params = {}) => async (dispatch) => {
  dispatch({ type: CREDIT_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.post(financePath(`credit/bc/${id}/reopen`), { ...params });
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: CREDIT_ACTIONS.ACTION_END });
    bcError(err, 'Failed to reopen Committee (BC)');
    return null;
  }
};
